import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Banner, Button } from '@tryhackme/thm-ui-components';
import styled, { css } from 'styled-components';

const boldCardTextStyles = css`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  font-size: 2rem;
`;

export const StyledBanner = styled(Banner)`
  height: unset;
  background-color: ${({ theme }) => theme.colors.black};

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    &.lightBanner {
      background-color: ${({ theme }) => theme.colors.secondary.light};
    }
  }
`;

export const StyledBannerContent = styled.div`
  width: 100%;
  margin: 13rem auto 4rem auto;
  padding: 0 1.6rem;
  text-align: left;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledTypeText = styled.p`
  font-size: 2rem;
  line-height: 2.6rem;
  color: ${({ theme }) => theme.colors.grey['500']};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  text-transform: uppercase;
`;

export const StyledTitle = styled.h1`
  color: ${({ theme }) => theme.colors.grey['200']};
  margin: 0.8rem 0 1.8rem 0;
`;

export const StyledSummary = styled.p`
  font-size: 2rem;
  line-height: 2.6rem;
  color: ${({ theme }) => theme.colors.grey['200']};

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    font-size: 2.4rem;
    line-height: 3.5rem;
  }
`;

export const StyledBannerCardRow = styled.div`
  margin: 2.4rem 0;
  display: flex;
  flex-wrap: wrap;
  gap: 1.6rem;
`;

export const StyledBannerCard = styled.div`
  width: 19rem;
  height: 8.6rem;
  display: flex;
  padding: 1.6rem;
  gap: 0.8rem;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.secondary.main};
  color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radius.small};
`;

export const StyledBannerCardLabel = styled.div`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
`;

export const StyledStatisticsBoxIconNumberContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const StyledBannerCardIcon = styled(FontAwesomeIcon)`
  height: 1.8rem;
`;

export const StyledBannerCardNumber = styled.span`
  ${boldCardTextStyles};
`;

export const StyledDifficulty = styled.div`
  p {
    ${boldCardTextStyles};
    line-height: unset;
  }
`;

export const StyledButton = styled(Button)`
  height: 5rem;
  min-width: 16.2rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
`;
